<template>
  <div class="app-container">
    <div class="tabs-bg">
      <el-tabs v-model="activeTab" @tab-click="handleTabClick">
        <el-tab-pane label="全部设备" name="all"></el-tab-pane>
        <el-tab-pane label="在线" name="online"></el-tab-pane>
        <el-tab-pane label="离线" name="offline"></el-tab-pane>
        <el-tab-pane label="满溢" name="overflow"></el-tab-pane>
        <el-tab-pane label="烟感" name="smoke"></el-tab-pane>
        <el-tab-pane label="控制" name="control"></el-tab-pane>
        <el-tab-pane label="称重" name="weight"></el-tab-pane>
        <el-tab-pane label="投递口" name="slot"></el-tab-pane>
      </el-tabs>
    </div>

    <div class="summary-card">
      <div class="card-header">
        <div class="title-bar"></div>
        <span class="title">设备信息概览</span>
      </div>
      <div class="summary-content">
        <div class="stat-item">
          <div class="stat-value blue">{{ summaryTotal }}</div>
          <div class="stat-label">设备总数</div>
        </div>
        <div class="stat-item">
          <div class="stat-value green">{{ onlineCount }}</div>
          <div class="stat-label">在线设备</div>
        </div>
        <div class="stat-item">
          <div class="stat-value red">{{ offlineCount }}</div>
          <div class="stat-label">离线设备</div>
        </div>
        <div class="stat-item">
          <div class="stat-value orange">{{ overflowCount }}</div>
          <div class="stat-label">满溢设备</div>
        </div>
      </div>
    </div>

    <!-- Filter Area -->
    <div class="search-card">
      <el-form :model="searchParams" inline class="filter-form" size="small">
        <el-form-item label="名称">
          <el-input v-model="searchParams.device_name" placeholder="名称" clearable style="width: 100px;" />
        </el-form-item>
        <el-form-item label="编号">
          <el-input v-model="searchParams.device_code" placeholder="编号" clearable style="width: 100px;" />
        </el-form-item>
        <el-form-item label="分组">
          <el-select v-model="searchParams.group_id" placeholder="分组" clearable style="width: 100px;">
            <el-option v-for="g in boxGroups" :key="g.id" :label="(g.group_name || g.name)" :value="g.id" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="searchParams.province_code" placeholder="省" clearable style="width: 90px;"
            @change="onProvinceSelect">
            <el-option v-for="p in provinces" :key="p.code || p.id" :label="p.name" :value="p.code || p.id" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="searchParams.city_code" placeholder="市" clearable style="width: 90px;"
            @change="onCitySelect">
            <el-option v-for="c in cities" :key="c.code || c.id" :label="c.name" :value="c.code || c.id" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="searchParams.area_code" placeholder="区" clearable style="width: 90px;"
            @change="onAreaSelect">
            <el-option v-for="a in areas" :key="a.code || a.id" :label="a.name" :value="a.code || a.id" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="searchParams.street_code" placeholder="街道" clearable style="width: 90px;"
            @change="onStreetSelect">
            <el-option v-for="s in streets" :key="s.code || s.id" :label="s.name" :value="s.code || s.id" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="searchParams.community_code" placeholder="小区" clearable style="width: 110px;">
            <el-option v-for="cm in communities" :key="cm.code || cm.id" :label="cm.name" :value="cm.code || cm.id" />
          </el-select>
        </el-form-item>
        <el-form-item class="action-buttons">
          <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜</el-button>
          <el-button icon="el-icon-refresh" @click="handleReset">重</el-button>
          <el-button icon="el-icon-download" @click="handleExport">导</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- Table Area -->
    <div class="table-card">
      <el-table :data="devicesData" fit highlight-current-row style="width: 100%;" v-loading="loading" :header-cell-style="{background:'#f5f7fa',color:'#606266'}" size="small">
        <el-table-column prop="id" label="编号" width="80" align="center" />
        <el-table-column prop="device_code" label="设备编码" min-width="140" align="center" />
        <el-table-column prop="container_name" label="设备名称" min-width="140" align="center" />
        
        <el-table-column label="所属小区" min-width="160" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row && scope.row.community_txt" style="cursor: pointer; color: #409EFF;" @click="linkSearchByCommunity(scope.row)">
              {{ scope.row.community_txt }}
            </span>
            <span v-else>未关联小区</span>
          </template>
        </el-table-column>

        <el-table-column label="所属行政区" min-width="240" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row && (scope.row.province_txt || scope.row.city_txt || scope.row.area_txt || scope.row.street_txt)">
              <span v-if="scope.row.province_txt" style="cursor: pointer; color: #409EFF;" @click="linkSearchByProvince(scope.row)">{{ scope.row.province_txt }}</span>
              <span v-else>-</span>
              /
              <span v-if="scope.row.city_txt" style="cursor: pointer; color: #409EFF;" @click="linkSearchByCity(scope.row)">{{ scope.row.city_txt }}</span>
              <span v-else>-</span>
              /
              <span v-if="scope.row.area_txt" style="cursor: pointer; color: #409EFF;" @click="linkSearchByArea(scope.row)">{{ scope.row.area_txt }}</span>
              <span v-else>-</span>
              /
              <span v-if="scope.row.street_txt" style="cursor: pointer; color: #409EFF;" @click="linkSearchByStreet(scope.row)">{{ scope.row.street_txt }}</span>
              <span v-else>-</span>
            </span>
            <span v-else>未关联行政区</span>
          </template>
        </el-table-column>

        <el-table-column prop="install_address" label="安装地址" min-width="180" show-overflow-tooltip align="center" />
        <el-table-column prop="install_time" label="安装时间" width="160" align="center" />
        <el-table-column prop="container_recycle_price" label="回收单价" width="100" align="center" />
        <el-table-column prop="recycle_mode" label="回收模式" width="120" align="center">
          <template slot-scope="scope">
            <el-tag size="small" effect="plain">{{ getRecycleModeName(scope.row.recycle_mode) }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="hardware_status" label="硬件状态" min-width="160" align="center">
          <template slot-scope="scope">
            <div v-if="scope.row.hardware_status" class="hardware-status-tags">
              <el-tag :type="getStatusTagType(scope.row.hardware_status[0])" size="mini"
                v-if="scope.row.hardware_status[0] === '1'">满溢</el-tag>
              <el-tag :type="getStatusTagType(scope.row.hardware_status[1])" size="mini"
                v-if="scope.row.hardware_status[1] === '1'">烟感</el-tag>
              <el-tag :type="getStatusTagType(scope.row.hardware_status[2])" size="mini"
                v-if="scope.row.hardware_status[2] === '1'">失控</el-tag>
              <el-tag :type="getStatusTagType(scope.row.hardware_status[3])" size="mini"
                v-if="scope.row.hardware_status[3] === '1'">称重</el-tag>
              <el-tag :type="getStatusTagType(scope.row.hardware_status[4])" size="mini"
                v-if="scope.row.hardware_status[4] === '1'">满溢</el-tag>
              <el-tag type="success" size="mini" v-if="!hasAnyHardwareIssue(scope.row.hardware_status)">正常</el-tag>
              <span v-else-if="!scope.row.hardware_status">--</span>
            </div>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column label="状态" min-width="70" align="center">
          <template slot-scope="scope">
            <span :style="{ color: scope.row.is_online ? 'green' : 'red' }">
              {{ scope.row.is_online ? '在线' : '离线' }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="company_id" label="公司编号" width="100" align="center" />
        <el-table-column prop="holder_user_id" label="持有人编号" width="100" align="center" />
        <el-table-column label="分组" min-width="140" align="center">
          <template slot-scope="scope">
            <span>{{ getGroupNames(scope.row.groups) }}</span>
          </template>
        </el-table-column>
      
        <el-table-column prop="created_at" label="创建时间" width="160" align="center" />
        <el-table-column label="操作" width="220" fixed="right" align="center">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="openReissueDialog(scope.row)">补发记录</el-button>
            <el-button type="text" size="small" @click="openDeliveryDialog(scope.row)">投递记录</el-button>
            <el-button type="text" size="small" @click="openClearanceDialog(scope.row)">清运记录</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- Pagination -->
      <div class="pagination-wrapper">
        <el-pagination background layout="total, sizes, prev, pager, next, jumper" :total="totalDevices"
          :page-sizes="[10, 20, 50, 100]" :current-page="pagination.currentPage" :page-size="pagination.page_size"
          @size-change="handleSizeChange" @current-change="handleCurrentChange" />
      </div>
    </div>


    <!-- Dialogs -->
    <el-dialog title="补发记录" :visible.sync="reissueDialogVisible" width="500px">
      <el-form label-width="110px">
        <el-form-item label="设备编号">
          <el-input v-model="reissueForm.device_code" disabled />
        </el-form-item>
        <el-form-item label="用户编号">
          <el-input v-model="reissueForm.user_id" placeholder="请输入用户编号" />
        </el-form-item>
        <el-form-item label="补发金额">
          <el-input v-model="reissueForm.reissue_amount" type="number" placeholder="请输入补发金额" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="reissueDialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="reissueSubmitting" @click="submitReissue">确认</el-button>
      </span>
    </el-dialog>

    <el-dialog title="投递管理" :visible.sync="deliveryDialogVisible" width="90%" top="5vh" append-to-body destroy-on-close>
      <Delivery ref="deliveryDialogComp" />
      <span slot="footer" class="dialog-footer">
        <el-button @click="deliveryDialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>

    <el-dialog title="清运管理" :visible.sync="clearanceDialogVisible" width="90%" top="5vh" append-to-body
      destroy-on-close>
      <Clearance ref="clearanceDialogComp" />
      <span slot="footer" class="dialog-footer">
        <el-button @click="clearanceDialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getDevices, getDevicesStatsPage } from '@/api/device'
import request from '@/api/interceptor'
import { reissueDelivery } from '@/api/finance'
import Delivery from '@/views/operation-management/Delivery.vue'
import Clearance from '@/views/operation-management/Clearance.vue'

export default {
  name: 'Devices',
  components: { Delivery, Clearance },
  data() {
    return {
      activeTab: 'all',
      loading: false,
      searchParams: {
        device_code: '',
        device_name: '',
        company_id: '',
        hardware_status: [],
        group_id: '',
        province_code: '',
        city_code: '',
        area_code: '',
        street_code: '',
        community_code: ''
      },
      pagination: {
        currentPage: 1,
        page_size: 10
      },
      totalDevices: 0,
      onlineCount: 0,
      offlineCount: 0,
      overflowCount: 0,
      devicesData: [],
      reissueDialogVisible: false,
      reissueSubmitting: false,
      reissueForm: {
        device_code: '',
        user_id: '',
        reissue_amount: ''
      },
      deliveryDialogVisible: false,
      clearanceDialogVisible: false,
      currentDeviceCode: '',
      boxGroups: [],
      provinces: [],
      cities: [],
      areas: [],
      streets: [],
      communities: []
    }
  },
  created() {
    const q = this.$route && this.$route.query ? this.$route.query : {}
    if (q.hardware_status) {
      this.searchParams.hardware_status = [String(q.hardware_status)]
    }
    this.fetchDevices()
    this.fetchBoxGroups()
    this.fetchProvinces()
  },
  methods: {
    async fetchDevices() {
      this.loading = true
      try {
        const params = {
          ...this.searchParams,
          page: this.pagination.currentPage,
          page_size: this.pagination.page_size
        }

        // 重置 status 和 hardware_status，避免残留
        params.status = undefined
        params.hardware_status = undefined

        switch (this.activeTab) {
          case 'all':
            break
          case 'online':
          case 'offline':
          case 'error':
            params.status = this.activeTab
            break
          case 'overflow':
            params.hardware_status = 1
            break
          case 'smoke':
            params.hardware_status = 2
            break
          case 'control':
            params.hardware_status = 4
            break
          case 'weight':
            params.hardware_status = 8
            break
          case 'slot':
            params.hardware_status = 16
            break
        }

        // 删除所有空入参：空字符串、undefined、null、空数组
        Object.keys(params).forEach((key) => {
          const val = params[key]
          if (val === '' || val === undefined || val === null || (Array.isArray(val) && val.length === 0)) {
            delete params[key]
          }
        })

        const response = await getDevices(params)
        if (!response) {
          this.$message.error('获取设备列表失败：无效的响应数据')
          return
        }
        const isSuccess = response.success || response.code === 0 || response.code === 'SUCCESS' || response.code === 200
        if (isSuccess) {
          const data = response.data || response;
          if (Array.isArray(data)) {
            this.devicesData = data;
            this.totalDevices = data.length;
            this.summaryTotal = data.length;
            this.onlineCount = 0;
            this.offlineCount = 0;
            this.overflowCount = 0;
          } else if (data.devices) {
            this.devicesData = data.devices || [];
            this.totalDevices = data.total || 0;
            this.summaryTotal = data.total_devices || data.total || 0;
            this.onlineCount = data.online_devices || 0;
            this.offlineCount = data.offline_devices || 0;
            this.overflowCount = data.overflow_devices || 0;
          } else {
            this.devicesData = data ? [data] : [];
            this.totalDevices = data ? 1 : 0;
            this.summaryTotal = data ? 1 : 0;
            this.onlineCount = 0;
            this.offlineCount = 0;
            this.overflowCount = 0;
          }
        } else {
          this.$message.error('获取设备列表失败：' + (response.message || response.msg || '未知错误'))
        }
      } catch (error) {
        console.error('获取设备列表失败:', error)
        this.$message.error('获取设备列表失败，请稍后重试')
      } finally {
        this.loading = false
      }
    },
    async fetchBoxGroups() {
      try {
        const res = await request({ url: '/v1/box-groups', method: 'get', params: { page: 1, page_size: 100 } })
        const outer = res && res.data ? res.data : res
        const inner = outer && outer.data ? outer.data : outer
        const payload = inner && inner.data ? inner.data : inner
        const groups = Array.isArray(payload && payload.groups) ? payload.groups : (Array.isArray(payload && payload.data) ? payload.data : [])
        this.boxGroups = groups
      } catch (e) {
        this.boxGroups = []
      }
    },
    async fetchProvinces() {
      try {
        const res = await request({ url: '/v1/divisions', method: 'get' })
        const body = res && res.data ? res.data : res
        const list = Array.isArray(body) ? body : (Array.isArray(body && body.data) ? body.data : [])
        this.provinces = list
      } catch (e) {
        this.provinces = []
      }
    },
    async fetchCities(code) {
      try {
        const res = await request({ url: '/v1/divisions', method: 'get', params: { code } })
        const body = res && res.data ? res.data : res
        const list = Array.isArray(body) ? body : (Array.isArray(body && body.data) ? body.data : [])
        this.cities = list
      } catch (e) {
        this.cities = []
      }
    },
    async fetchAreas(code) {
      try {
        const res = await request({ url: '/v1/divisions', method: 'get', params: { code } })
        const body = res && res.data ? res.data : res
        const list = Array.isArray(body) ? body : (Array.isArray(body && body.data) ? body.data : [])
        this.areas = list
      } catch (e) {
        this.areas = []
      }
    },
    async fetchStreets(code) {
      try {
        const res = await request({ url: '/v1/divisions', method: 'get', params: { code } })
        const body = res && res.data ? res.data : res
        const list = Array.isArray(body) ? body : (Array.isArray(body && body.data) ? body.data : [])
        this.streets = list
      } catch (e) {
        this.streets = []
      }
    },
    async fetchCommunities(code) {
      try {
        const res = await request({ url: '/v1/divisions', method: 'get', params: { code } })
        const body = res && res.data ? res.data : res
        const list = Array.isArray(body) ? body : (Array.isArray(body && body.data) ? body.data : [])
        this.communities = list
      } catch (e) {
        this.communities = []
      }
    },
    handleTabClick() {
      this.pagination.currentPage = 1;
      this.fetchDevices();
    },
    handleSearch() {
      this.pagination.currentPage = 1
      this.fetchDevices()
    },
    handleReset() {
      this.searchParams = {
        device_code: '',
        device_name: '',
        company_id: '',
        group_id: '',
        province_code: '',
        city_code: '',
        area_code: '',
        street_code: '',
        community_code: '',
        community_txt: '',
        province_txt: '',
        city_txt: '',
        area_txt: '',
        street_txt: ''
      }
      this.cities = []
      this.areas = []
      this.streets = []
      this.communities = []
      this.pagination.currentPage = 1
      this.fetchDevices()
    },
    linkSearchByCommunity(row) {
      const province_code = row && (row.province_code || row.province_id)
      const city_code = row && (row.city_code || row.city_id)
      const area_code = row && (row.area_code || row.area_id)
      const street_code = row && (row.street_code || row.street_id)
      const community_code = row && (row.community_code || row.community_id)
      this.searchParams.province_code = province_code || ''
      this.searchParams.city_code = city_code || ''
      this.searchParams.area_code = area_code || ''
      this.searchParams.street_code = street_code || ''
      this.searchParams.community_code = community_code || ''
      this.searchParams.community_txt = ''
      this.searchParams.province_txt = ''
      this.searchParams.city_txt = ''
      this.searchParams.area_txt = ''
      this.searchParams.street_txt = ''
      this.pagination.currentPage = 1
      this.fetchDevices()
    },
    linkSearchByProvince(row) {
      const province_code = row && (row.province_code || row.province_id)
      this.searchParams.province_code = province_code || ''
      this.searchParams.city_code = ''
      this.searchParams.area_code = ''
      this.searchParams.street_code = ''
      this.searchParams.community_code = ''
      this.searchParams.community_txt = ''
      this.searchParams.province_txt = ''
      this.searchParams.city_txt = ''
      this.searchParams.area_txt = ''
      this.searchParams.street_txt = ''
      this.pagination.currentPage = 1
      this.fetchDevices()
    },
    linkSearchByCity(row) {
      const province_code = row && (row.province_code || row.province_id)
      const city_code = row && (row.city_code || row.city_id)
      this.searchParams.province_code = province_code || ''
      this.searchParams.city_code = city_code || ''
      this.searchParams.area_code = ''
      this.searchParams.street_code = ''
      this.searchParams.community_code = ''
      this.searchParams.community_txt = ''
      this.searchParams.province_txt = ''
      this.searchParams.city_txt = ''
      this.searchParams.area_txt = ''
      this.searchParams.street_txt = ''
      this.pagination.currentPage = 1
      this.fetchDevices()
    },
    linkSearchByArea(row) {
      const province_code = row && (row.province_code || row.province_id)
      const city_code = row && (row.city_code || row.city_id)
      const area_code = row && (row.area_code || row.area_id)
      this.searchParams.province_code = province_code || ''
      this.searchParams.city_code = city_code || ''
      this.searchParams.area_code = area_code || ''
      this.searchParams.street_code = ''
      this.searchParams.community_code = ''
      this.searchParams.community_txt = ''
      this.searchParams.province_txt = ''
      this.searchParams.city_txt = ''
      this.searchParams.area_txt = ''
      this.searchParams.street_txt = ''
      this.pagination.currentPage = 1
      this.fetchDevices()
    },
    linkSearchByStreet(row) {
      const province_code = row && (row.province_code || row.province_id)
      const city_code = row && (row.city_code || row.city_id)
      const area_code = row && (row.area_code || row.area_id)
      const street_code = row && (row.street_code || row.street_id)
      this.searchParams.province_code = province_code || ''
      this.searchParams.city_code = city_code || ''
      this.searchParams.area_code = area_code || ''
      this.searchParams.street_code = street_code || ''
      this.searchParams.community_code = ''
      this.searchParams.community_txt = ''
      this.searchParams.province_txt = ''
      this.searchParams.city_txt = ''
      this.searchParams.area_txt = ''
      this.searchParams.street_txt = ''
      this.pagination.currentPage = 1
      this.fetchDevices()
    },
    onProvinceSelect(code) {
      this.searchParams.city_code = ''
      this.searchParams.area_code = ''
      this.searchParams.street_code = ''
      this.searchParams.community_code = ''
      this.searchParams.community_txt = ''
      this.searchParams.province_txt = ''
      this.searchParams.city_txt = ''
      this.searchParams.area_txt = ''
      this.searchParams.street_txt = ''
      this.cities = []
      this.areas = []
      this.streets = []
      this.communities = []
      if (code) this.fetchCities(code)
    },
    onCitySelect(code) {
      this.searchParams.area_code = ''
      this.searchParams.street_code = ''
      this.searchParams.community_code = ''
      this.searchParams.community_txt = ''
      this.searchParams.province_txt = ''
      this.searchParams.city_txt = ''
      this.searchParams.area_txt = ''
      this.searchParams.street_txt = ''
      this.areas = []
      this.streets = []
      this.communities = []
      if (code) this.fetchAreas(code)
    },
    onAreaSelect(code) {
      this.searchParams.street_code = ''
      this.searchParams.community_code = ''
      this.searchParams.community_txt = ''
      this.searchParams.province_txt = ''
      this.searchParams.city_txt = ''
      this.searchParams.area_txt = ''
      this.searchParams.street_txt = ''
      this.streets = []
      this.communities = []
      if (code) this.fetchStreets(code)
    },
    onStreetSelect(code) {
      this.searchParams.community_code = ''
      this.searchParams.community_txt = ''
      this.searchParams.province_txt = ''
      this.searchParams.city_txt = ''
      this.searchParams.area_txt = ''
      this.searchParams.street_txt = ''
      this.communities = []
      if (code) this.fetchCommunities(code)
    },
    handleCreateDevice() {
      this.$message.info('新增设备功能待实现');
    },
    async handleExport() {
      try {
        this.$loading({ text: '正在导出...' })
        const allRows = []
        const page_size = 100
        const first = await getDevicesStatsPage({ page: 1, page_size })

        const total = Number(first.total) || 0
        const firstRows = Array.isArray(first.data) ? first.data : []
        allRows.push(...firstRows)
        const totalPages = Math.max(1, Math.ceil(total / page_size))
        for (let p = 2; p <= totalPages; p++) {
          const res = await getDevicesStatsPage({ page: p, page_size })
          if (!res || (res.code !== 0 && res.code !== 'SUCCESS')) break
          const rows = Array.isArray(res.data) ? res.data : []
          allRows.push(...rows)
        }
        if (allRows.length === 0) {
          this.$message.warning('没有可导出的数据')
          return
        }
        const headers = ['设备编号', '设备名称', '安装时间', '运行天数', '总投递重量', '注册用户数']
        const tableRows = allRows.map(r => [
          r.device_code || '',
          r.device_name || '',
          r.install_time || '',
          r.running_days != null ? r.running_days : '',
          r.total_delivery_weight != null ? r.total_delivery_weight : '',
          r.total_registered_users != null ? r.total_registered_users : ''
        ])
        const tableHtml = [
          '<table border="1">',
          `<tr>${headers.map(h => `<th>${h}</th>`).join('')}</tr>`,
          ...tableRows.map(row => `<tr>${row.map(v => `<td>${v}</td>`).join('')}</tr>`),
          '</table>'
        ].join('')
        const blob = new Blob([`\ufeff${tableHtml}`], { type: 'application/vnd.ms-excel;charset=utf-8' })
        const url = URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = url
        a.download = `设备统计_${new Date().toISOString().slice(0, 10)}.xls`
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
        URL.revokeObjectURL(url)
        this.$message.success('导出成功')
      } catch (e) {
        this.$message.error('导出失败')
      } finally {
        this.$loading().close()
      }
    },
    hasAnyHardwareIssue(statusStr) {
      if (!statusStr || statusStr.length !== 5) return false
      return statusStr.includes('1')
    },
    getStatusTagType(statusChar) {
      return statusChar === '1' ? 'danger' : 'success'
    },
    getGroupNames(groups) {
      if (groups == null) return '无分组'
      if (Array.isArray(groups)) {
        if (groups.length === 0) return '无分组'
        const names = groups.map(g => g.group_name).filter(Boolean)
        return names.length ? Array.from(new Set(names)).join('、') : '无分组'
      }
      if (typeof groups === 'string') {
        const trimmed = groups.trim()
        if (!trimmed || trimmed === '[]') return '无分组'
        try {
          const arr = JSON.parse(trimmed)
          if (Array.isArray(arr) && arr.length > 0) {
            const names = arr.map(g => g.group_name).filter(Boolean)
            return names.length ? Array.from(new Set(names)).join('、') : '无分组'
          }
          return '无分组'
        } catch (e) {
          return '无分组'
        }
      }
      return '无分组'
    },
    handleSizeChange(size) {
      this.pagination.page_size = size
      this.fetchDevices()
    },
    handleCurrentChange(current) {
      this.pagination.currentPage = current
      this.fetchDevices()
    },
    getRecycleModeName(mode) {
      const modeMap = {
        1: '投递给钱，开箱付费',
        2: '投递给钱，开箱免费',
        3: '投递给钱，开箱免费，持有人获得差额',
        4: '投递给钱，开箱付费，持有人获得差额',
        5: '合作模式，开箱免费，持有人获得差额',
        6: '合作模式，开箱付费，持有人获得差额'
      }
      return modeMap[mode] || `未知模式(${mode})`
    },
    openReissueDialog(row) {
      this.reissueForm = {
        device_code: row.device_code || '',
        user_id: '',
        reissue_amount: ''
      }
      this.reissueDialogVisible = true
    },
    async submitReissue() {
      if (!this.reissueForm.device_code) {
        this.$message.error('设备编号不能为空')
        return
      }
      if (!this.reissueForm.user_id) {
        this.$message.error('请输入用户编号')
        return
      }
      if (this.reissueForm.reissue_amount === '' || this.reissueForm.reissue_amount === null) {
        this.$message.error('请输入补发金额')
        return
      }
      this.reissueSubmitting = true
      try {
        const payload = {
          device_code: this.reissueForm.device_code,
          user_id: parseInt(this.reissueForm.user_id),
          reissue_amount: Number(this.reissueForm.reissue_amount)
        }
        const res = await reissueDelivery(payload)
        if (res && (res.code === 0 || res.success === true || res.code === 200 || res.code === 'SUCCESS')) {
          this.$message.success('补发记录提交成功')
          this.reissueDialogVisible = false
        } else {
          this.$message.error(res && (res.message || res.msg) ? (res.message || res.msg) : '补发记录提交失败')
        }
      } catch (e) {
        console.error('submitReissue error:', e)
        this.$message.error('补发记录提交失败，请稍后重试')
      } finally {
        this.reissueSubmitting = false
      }
    },
    async openDeliveryDialog(row) {
      this.currentDeviceCode = row.device_code || ''
      this.deliveryDialogVisible = true
      this.$nextTick(() => {
        const comp = this.$refs.deliveryDialogComp
        if (comp && comp.searchParams) {
          comp.searchParams.device_code = this.currentDeviceCode
          comp.pagination.currentPage = 1
          if (typeof comp.handleSearch === 'function') comp.handleSearch()
          else if (typeof comp.fetchDeliveries === 'function') comp.fetchDeliveries()
        }
      })
    },
    async openClearanceDialog(row) {
      this.currentDeviceCode = row.device_code || ''
      this.clearanceDialogVisible = true
      this.$nextTick(() => {
        const comp = this.$refs.clearanceDialogComp
        if (comp && comp.searchParams) {
          comp.searchParams.device_code = this.currentDeviceCode
          comp.searchParams.page = 1
          if (typeof comp.handleSearch === 'function') comp.handleSearch()
          else if (typeof comp.fetchCleaningLogs === 'function') comp.fetchCleaningLogs()
        }
      })
    }
  }
}
</script>

<style scoped>
.app-container {
  padding: 10px;
  background-color: #f4f6f8;
  min-height: 100vh;
}

/* Tabs */
.tabs-bg {
  background: #fff;
  padding: 10px 20px 0;
  border-radius: 4px;
  margin-bottom: 10px;
}

::v-deep .el-tabs__nav-wrap::after {
  height: 0;
}

::v-deep .el-tabs__item.is-active {
  color: #28b652;
}

::v-deep .el-tabs__active-bar {
  background-color: #28b652;
}

::v-deep .el-tabs__item:hover {
  color: #28b652;
}

::v-deep .el-tabs__item {
  height: 40px;
  line-height: 40px;
  font-size: 14px;
}

/* Summary Card */
.summary-card {
  background: #fff;
  padding: 12px 20px;
  border-radius: 4px;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
}

.card-header {
  display: flex;
  align-items: center;
  margin-bottom: 0;
  margin-right: 40px;
  min-width: 140px;
}

.title-bar {
  width: 4px;
  height: 16px;
  background: #28b652;
  margin-right: 10px;
  border-radius: 2px;
}

.title {
  font-size: 16px;
  font-weight: bold;
  color: #333;
}

.summary-content {
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex: 1;
}

.stat-item {
  text-align: center;
}

.stat-value {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 4px;
}

.stat-value.blue {
  color: #409EFF;
}

.stat-value.green {
  color: #67C23A;
}

.stat-value.red {
  color: #F56C6C;
}

.stat-value.orange {
  color: #E6A23C;
}

.stat-label {
  font-size: 12px;
  color: #909399;
}

/* Search Card */
.search-card {
  background: #fff;
  padding: 18px 5px 0;
  border-radius: 4px;
  margin-bottom: 10px;
  white-space: nowrap;
  overflow-x: hidden;
}

.filter-form .el-form-item {
  margin-bottom: 18px;
  margin-right: 2px;
}

.filter-form .el-form-item.action-buttons {
  margin-right: 0;
}

/* Table Card */
.table-card {
  background: #fff;
  padding: 20px;
  border-radius: 4px;
}

.pagination-wrapper {
  margin-top: 20px;
  text-align: right;
}

.hardware-status-tags {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 6px;
}
</style>
